export default __webpack_public_path__ + "static/media/dog-page.fd47b65e.PNG";